// extracted by mini-css-extract-plugin
module.exports = {"action":"ClientAllowanceItemsComponent__action--3373d"};